import React from 'react';
import { CTAOfferButton } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { deepCoveDark } from '../../../components/loggedout/shared-styles/Colors';

import { Link } from 'react-router-dom';
import * as S from './style';
import GradeWave from '~images/sem/grade-wave.png';
import Image from '../../../components/loggedout/common/Image';
import DashboardIllustrationImg from "~images/oddbods/dashboard-illustration.png"
import { isMobileDevice } from '../../../utils/web-helper';
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';

const SplashUniverse = ({btnClickEvent, ctaText, urlToRedirect }) => {
  // let ctaText = 'Sign up for free';
  const content_text1 = isMobileDevice() ? 'Explore exclusive books that follow the adventures of ' : 'Come explore exclusive books that follow the adventures and shenanigans of ';
  const content_text2 = isMobileDevice() ? 'SplashLearn is an ever-expanding universe of learning games, activities, and books that make learning fun.' : 'SplashLearn is an ever-expanding universe of learning games, activities, and books that help kids learn while having fun.'
  
  return (
    <S.ContainerWrapper>
      <S.WaveWrapper>
        <Image alt="image" src={GradeWave} />
      </S.WaveWrapper>
      <S.Wrapper>
        <S.ImageWrapper>
          <Image alt="image" src={DashboardIllustrationImg} />
        </S.ImageWrapper>
        <S.ContentWrapper>
            <S.HeadingText>Learning that's fun? What are the odds!</S.HeadingText>
            <S.Content>
              {content_text1}<b>Pogo, Fuse, Bubbles, Newt, Zee, Slick and Jeff.</b></S.Content>
            <S.Content>{content_text2}</S.Content>
        </S.ContentWrapper>
      </S.Wrapper>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <a href={urlToRedirect} onClick={btnClickEvent}>
            {ctaText}
          </a>
        </CTAOfferButton>
      </S.ButtonWrapper>
    </S.ContainerWrapper>
  )
}
export default SplashUniverse;